import { categories, mangaList } from '@/mocks/manga';
import MangaCard from '@/components/feature/MangaCard';

interface LatestProps {
  query: string;
  activeCategory: string;
  setActiveCategory: (value: string) => void;
}

const tabs = ['全部', ...categories.map((c) => c.name)];

export default function Latest({ query, activeCategory, setActiveCategory }: LatestProps) {
  const keyword = query.trim().toLowerCase();
  const filtered = mangaList.filter((manga) => {
    const matchCat = activeCategory === '全部' || manga.category === activeCategory;
    const matchQuery =
      keyword.length === 0 ||
      manga.title.toLowerCase().includes(keyword) ||
      manga.tags.some((t) => t.toLowerCase().includes(keyword)) ||
      manga.category.toLowerCase().includes(keyword) ||
      manga.description.toLowerCase().includes(keyword);
    return matchCat && matchQuery;
  });

  return (
    <section id="latest" className="scroll-mt-20 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-arrow-up-circle-fill" /> 每日扩充
            </span>
            <h2 className="font-display mt-3 text-2xl font-bold text-foreground-900 md:text-4xl">
              最新更新 · 作品库
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              当前筛选出 <strong className="text-primary-700">{filtered.length}</strong> 部作品
              {activeCategory !== '全部' && <span> · 分类：{activeCategory}</span>}
            </p>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActiveCategory(tab)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                activeCategory === tab
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {filtered.length > 0 ? (
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            {filtered.map((manga) => (
              <MangaCard key={manga.id} manga={manga} />
            ))}
          </div>
        ) : (
          <div className="mt-8 flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-20 text-center">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-400">
              <i className="ri-search-line text-2xl" />
            </span>
            <p className="mt-4 font-display text-lg font-bold text-foreground-800">没有找到相关作品</p>
            <p className="mt-1 text-sm text-foreground-500">
              试试更换关键词，或切换到「全部」分类再找找看。
            </p>
            <button
              type="button"
              onClick={() => {
                setActiveCategory('全部');
              }}
              className="mt-5 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              重置筛选
            </button>
          </div>
        )}
      </div>
    </section>
  );
}